module.exports = __webpack_public_path__ + "img/32book.3cfe0ffe.png";